import { render, staticRenderFns } from "./CloseAccountModal.vue?vue&type=template&id=6903c22d&scoped=true&"
import script from "./CloseAccountModal.vue?vue&type=script&lang=js&"
export * from "./CloseAccountModal.vue?vue&type=script&lang=js&"
import style0 from "./CloseAccountModal.vue?vue&type=style&index=0&id=6903c22d&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6903c22d",
  null
  
)

export default component.exports